<template>
    <v-container fluid class="pa-4">
        <v-card class="mb-4">
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-receipt-text</v-icon>
                Note Spese
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="openNew">
                    <v-icon left small>mdi-plus</v-icon>
                    Nuova nota spese
                </v-btn>
                <v-btn icon class="ml-2" @click="load" :loading="loading"><v-icon>mdi-refresh</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <v-row align="center" dense>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            v-model="filterEmployee"
                            :items="employees"
                            item-text="text"
                            item-value="value"
                            label="Dipendente"
                            prepend-icon="mdi-account-tie"
                            outlined
                            dense
                            hide-details
                            clearable
                            @change="load"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select
                            v-model="filterStatus"
                            :items="statuses"
                            label="Stato"
                            prepend-icon="mdi-list-status"
                            outlined
                            dense
                            hide-details
                            clearable
                            @change="load"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-data-table :headers="headers" :items="items" :loading="loading" :items-per-page="25">
                <template v-slot:item.period="{ item }">{{ monthName(item.period_month) }} {{ item.period_year }}</template>
                <template v-slot:item.total_amount="{ item }"><strong>{{ formatCurrency(item.total_amount) }}</strong></template>
                <template v-slot:item.status="{ item }">
                    <v-chip small :color="statusColor(item.status)" text-color="white">{{ statusText(item.status) }}</v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn v-if="item.status === 'draft'" icon small color="primary" @click="submit(item)" title="Invia">
                        <v-icon small>mdi-send</v-icon>
                    </v-btn>
                    <v-btn v-if="item.status === 'submitted'" icon small color="success" @click="approve(item)" title="Approva">
                        <v-icon small>mdi-check</v-icon>
                    </v-btn>
                    <v-btn v-if="item.status === 'approved'" icon small color="blue" @click="reimburse(item)" title="Rimborsa">
                        <v-icon small>mdi-cash-check</v-icon>
                    </v-btn>
                    <v-btn icon small @click="openDetail(item)" title="Dettaglio">
                        <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>

        <!-- Dialog nuova nota -->
        <v-dialog v-model="newDialog" max-width="500">
            <v-card>
                <v-card-title><v-icon left color="primary">mdi-receipt-text-plus</v-icon>Nuova nota spese</v-card-title>
                <v-card-text>
                    <v-autocomplete v-model="form.employee_id" :items="employees" item-text="text" item-value="value" label="Dipendente" prepend-icon="mdi-account-tie" outlined dense></v-autocomplete>
                    <v-row dense>
                        <v-col cols="6"><v-select v-model="form.period_month" :items="months" label="Mese" prepend-icon="mdi-calendar-month" outlined dense></v-select></v-col>
                        <v-col cols="6"><v-text-field v-model.number="form.period_year" type="number" label="Anno" prepend-icon="mdi-calendar" outlined dense></v-text-field></v-col>
                    </v-row>
                    <v-textarea v-model="form.notes" label="Note" prepend-icon="mdi-comment-text" outlined dense rows="2"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="newDialog = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="saving" @click="submitNew">Crea</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog dettaglio con righe -->
        <v-dialog v-model="detailDialog" max-width="900">
            <v-card v-if="detail">
                <v-card-title>
                    <v-icon left color="primary">mdi-receipt-text</v-icon>
                    Nota spese {{ detail.model ? monthName(detail.model.period_month) + ' ' + detail.model.period_year : '' }}
                    <v-spacer></v-spacer>
                    <v-btn small text @click="openExpenseForm">
                        <v-icon left small>mdi-plus</v-icon>Riga
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="expenseHeaders"
                        :items="detail.model ? detail.model.expenses : []"
                        disable-pagination hide-default-footer dense>
                        <template v-slot:item.date="{ item }">{{ formatDate(item.date) }}</template>
                        <template v-slot:item.amount="{ item }">{{ formatCurrency(item.amount) }}</template>
                    </v-data-table>

                    <v-card v-if="expenseDialog" outlined class="mt-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" md="3">
                                    <gmh-date-picker v-model="expenseForm.date" label="Data" editable></gmh-date-picker>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select
                                        v-model="expenseForm.category"
                                        :items="[
                                            {value:'meal',text:'Pasto'},
                                            {value:'travel',text:'Viaggio'},
                                            {value:'fuel',text:'Carburante'},
                                            {value:'lodging',text:'Alloggio'},
                                            {value:'other',text:'Altro'},
                                        ]"
                                        label="Categoria" outlined dense
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model.number="expenseForm.amount" type="number" step="0.01" label="Importo" prefix="€" outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="expenseForm.description" label="Descrizione" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <div class="text-right">
                                <v-btn text small @click="expenseDialog = false">Annulla</v-btn>
                                <v-btn color="primary" small @click="addExpense">Aggiungi</v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="detailDialog = false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { localDateStr } from '@/components/utilities/hrDates'
    export default {
        name: 'hr-expense-reports',

        data() {
            return {
                items: [],
                employees: [],
                filterEmployee: null,
                filterStatus: null,
                loading: false,
                saving: false,
                newDialog: false,
                form: { employee_id: null, period_year: new Date().getFullYear(), period_month: new Date().getMonth() + 1, notes: '' },
                detailDialog: false,
                detail: null,
                expenseDialog: false,
                expenseForm: { date: localDateStr(), category: 'meal', amount: 0, description: '' },
                statuses: [
                    { value: 'draft', text: 'Bozza' },
                    { value: 'submitted', text: 'Inviata' },
                    { value: 'approved', text: 'Approvata' },
                    { value: 'reimbursed', text: 'Rimborsata' },
                    { value: 'rejected', text: 'Rifiutata' },
                ],
                months: [
                    { value: 1, text: 'Gennaio' }, { value: 2, text: 'Febbraio' }, { value: 3, text: 'Marzo' },
                    { value: 4, text: 'Aprile' }, { value: 5, text: 'Maggio' }, { value: 6, text: 'Giugno' },
                    { value: 7, text: 'Luglio' }, { value: 8, text: 'Agosto' }, { value: 9, text: 'Settembre' },
                    { value: 10, text: 'Ottobre' }, { value: 11, text: 'Novembre' }, { value: 12, text: 'Dicembre' },
                ],
                headers: [
                    { text: 'Dipendente', value: 'employee_full_name' },
                    { text: 'Periodo', value: 'period' },
                    { text: 'Totale', value: 'total_amount' },
                    { text: 'Stato', value: 'status' },
                    { text: '', value: 'actions', sortable: false, align: 'end' },
                ],
                expenseHeaders: [
                    { text: 'Data', value: 'date' },
                    { text: 'Categoria', value: 'category' },
                    { text: 'Importo', value: 'amount' },
                    { text: 'Descrizione', value: 'description' },
                ],
            }
        },

        methods: {
            load() {
                this.loading = true
                const payload = {}
                if (this.filterEmployee) payload.employee_id = this.filterEmployee
                if (this.filterStatus) payload.status = this.filterStatus
                this.axios.post('hrexpensereports-filters', payload).then(r => {
                    this.items = r.data.data || []
                    this.loading = false
                }, () => { this.loading = false })
            },
            loadEmployees() {
                this.axios.post('hremployees-filters').then(r => {
                    const data = r.data.data && r.data.data.data ? r.data.data.data : (Array.isArray(r.data.data) ? r.data.data : [])
                    this.employees = data.map(e => ({ value: e.id, text: `${e.first_name || ''} ${e.last_name || ''}`.trim() || `#${e.id}` }))
                })
            },
            openNew() { this.form = { employee_id: null, period_year: new Date().getFullYear(), period_month: new Date().getMonth() + 1, notes: '' }; this.newDialog = true },
            submitNew() {
                this.saving = true
                this.axios.post('hrexpensereports', this.form).then(() => { this.saving = false; this.newDialog = false; this.load() }, () => { this.saving = false })
            },
            submit(item) { this.axios.post(`hrexpensereports/${item.id}/submit`).then(() => this.load()) },
            approve(item) { this.axios.post(`hrexpensereports/${item.id}/approve`).then(() => this.load()) },
            reimburse(item) { this.axios.post(`hrexpensereports/${item.id}/reimburse`).then(() => this.load()) },
            openDetail(item) {
                this.axios.get(`hrexpensereports/${item.id}`).then(r => {
                    this.detail = r.data
                    this.detailDialog = true
                })
            },
            openExpenseForm() {
                this.expenseForm = { date: localDateStr(), category: 'meal', amount: 0, description: '' }
                this.expenseDialog = true
            },
            addExpense() {
                const payload = Object.assign({}, this.expenseForm, {
                    expense_report_id: this.detail.model.id,
                    employee_id: this.detail.model.employee_id,
                })
                this.axios.post('hrexpenses', payload).then(() => {
                    this.expenseDialog = false
                    this.openDetail({ id: this.detail.model.id })
                    this.load()
                })
            },
            statusText(s) { return { draft: 'Bozza', submitted: 'Inviata', approved: 'Approvata', reimbursed: 'Rimborsata', rejected: 'Rifiutata' }[s] || s },
            statusColor(s) { return { draft: 'grey', submitted: 'orange', approved: 'green', reimbursed: 'blue', rejected: 'red' }[s] || 'grey' },
            monthName(m) { return (this.months.find(x => x.value === parseInt(m)) || {}).text || '' },
            formatDate(d) { return d ? new Date(d).toLocaleDateString('it-IT') : '—' },
            formatCurrency(v) { return v != null ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v) : '—' },
        },

        created() {
            this.$store.commit('endProgress')
            this.loadEmployees()
            this.load()
        },
    }
</script>
